<div class="pop-up">
  <div class="container border-bottom">
    <div class="name">DSCP</div>
    <div class="action">
      <button mat-flat-button class="add" [disabled]="disableAddButton" (click)="addDscpFlows()">
        ADD
      </button>
      <i class="mdi mdi-close close" mat-dialog-close></i>
    </div>
  </div>
  <div class="search-container border-bottom">
    <i class="mdi mdi-magnify report-search-bar"></i>
    <input
      class="search-input"
      matInput
      placeholder="Search by DSCP name"
      autocomplete="off"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchDscpFlow($event)"
    />
  </div>
  <div class="no-flows" *ngIf="!dataSource.length">No flows are available</div>
  <div *ngIf="dataSource.length">
    <div class="select-all border-bottom">
      <mat-checkbox
        color="primary"
        class="custom-frame"
        (change)="selectAllDscp()"
        [(ngModel)]="selectAll"
        (checked)="(selectAll)"
      ></mat-checkbox>
      <label class="label">Select All</label>
    </div>
    <div class="table-data">
      <table mat-table [dataSource]="dataSource" class="table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef style="display: none"></th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox
              class="custom-frame"
              color="primary"
              [checked]="element.checked"
              (change)="selectDscpFlow(element)"
            ></mat-checkbox>
            <label class="label">
              {{ element.id
              }}<span *ngIf="element.value != element.id">&nbsp;- {{ element.value }}</span></label
            >
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
